import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['index', 'serviceType', 'interfaceType', 'status']);
  const createConfigUsagePlatform = `createConfigUsagePlatform(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createConfigUsagePlatform} {
      id
    }
  }
`;
};
